/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { LayoutProps, rankWith, uiTypeIs } from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { useDynamicFormContext } from "../../../DynamicFormContext";

import { getActions } from "../../../../../utils/DynamicForms";

type Props = LayoutProps;

const LoaderLayout = (props: Props) => {
  const { formData, handleActions, setData } = useDynamicFormContext();
  const actions = getActions(props.uischema);

  useEffect(() => {
    if (formData?.paymentInfo && formData?.paymentInfo?.paymentSuccess) return;
    if (!actions?.length) return;
    if (!props.visible) {
      handleActions(actions);
      setData?.({ ...formData, isLoading: false });
    }
  }, [props.visible]);

  if (!props.visible) return null;

  return (
    <div className="tru-list-loading">
      <span className="loading-anim"></span>
    </div>
  );
};

export const LoaderLayoutEntry = {
  tester: rankWith(1, uiTypeIs("LoaderLayout")),
  renderer: withJsonFormsLayoutProps(LoaderLayout),
};
